var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_5510_15119)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5510_15119",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5510_15119",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5510_15119",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADM0lEQVR4nO3czU4TURjG8efMVMBgjKiJYRiaUqpcAhslfmAIO0yMrGTlwhvgInTrzriSnQvAuDDGkAisvABWtNjAQHdooiQUOz2u3OBUoL7T99R5fstp807pn2kPZxIAIiIiIiIiIiLKCpPm8CA/ct82vUcAbgE2BEx/muc7wfv+PvOgXC7XFV/DH1IJEAQjY9YzLwEzkcb8f+BcBPEAg8PXJ2CbywAGpGcLcSqCaIBr+RtFrxl/BnBVcm4KPvTm4plqtXqo/UI8yWF+M34F9998AJiqN/zlQqHQp/1CxAIEQXHSAnek5nXAVL3hL5ZKpV7NF5GTGmQ9M9vioboB5nty8UK1Wv0mdb6TDIaj9hRPmz44tEulUkntO0HyIyhxxWOA+b2o8qKTb/4Z/Y6gciVIBgiSDvbk4gXBc6RFLYJkgAtJBx3+zT9u+uDQvu30F7PoKqgbWGPf/eXhjq+OMhfgysXzD12KkLkAGxsbRy5FyFwAwK0ImQwAuBMhswEANyJkOgCgHyHzAQDdCGLb0a32XmpRJdW7bq2cci+oHaJb2bwCzm6q3vAXpYYxQHumpQYxgDIGUMYAysTuiLlGavWV4moKAK8AdQygjAGUMYAyBlDGAMoYQBkDKGMAZQygjAGUObcXlPbei9YdulZ4BShjAGUMoIwBlDGAMudWQa6tUtLGK0AZAyhjAGUMoIwBlDm3CpLaC+qW1RSvAGUMoIwBlDGAMgZQ5twqqFtWL1J4BShjAGUMoIwBlDGAMgZQxgDKGECZZIDvSQcLhcIlwXN0VBiGl1s8lPiztkMywF7SwaOGPyd4jo6K0fM4+RGzK3UOya2IdQBjxw9a4PlgWDTnvMbr7e3tr4LnS00+nx/42czNAeZZ8jPsmtS5xPZdgqA4aT3zUWqeyzxrJ3d3t1YkZolufAXh6IoF7krOdNBqLarclhomugryYJ8C6IqPmfaYfR94IjlRNEAUbW3CeDP4LyOYfZh4JooqZcmp4n8H1HY213zYcQCr0rMVffJhx2s7X9alB6d682NoqHivacwsLG7CYBgt/sO6g37AYgcG6561b6S+cImIiIiIiIiIKNt+Afh5CagXWakNAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.a0d490ced6029cb4662ed9c246787927.svg";
export { ForwardRef as ReactComponent };